import Vue from 'vue'
import Router from 'vue-router'
import Axios from 'axios'
import store from './store'

import ErrorsRoutes from '@/modules/errors/routes'
import AuthRoutes from '@/modules/auth/routes'
import DashboardRoutes from '@/modules/dashboard/routes'
import RefsRoutes from '@/modules/refs/routes'
import EvaluationsRoutes from '@/modules/evaluations/routes'
import PositionsRoutes from '@/modules/positions/routes'

import CandidatesRoutes from '@/modules/candidates/routes'
import FriendsRoutes from '@/modules/friends/routes'

import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

Vue.use(Router)

//===============================================
// Get routes from modules
//===============================================
const baseRoutes = []
const routes = baseRoutes.concat(AuthRoutes, ErrorsRoutes, DashboardRoutes, RefsRoutes, EvaluationsRoutes, CandidatesRoutes, PositionsRoutes, FriendsRoutes);

//===============================================
// Main app router
//===============================================
export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//===============================================
// Auth interceptor and redirect to login page
//===============================================
router.beforeEach((to, from, next) => {

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['Login', 'Oauth', 'SsoCallback', 'SurveyNew', 'CampaignSurveyNew', 'FriendNew']
    const authRequired = !publicPages.includes(to.name);
    const loggedIn = localStorage.getItem('jwt');

    if (authRequired && !loggedIn){
        return next('/login');
    }else{
        if(loggedIn){
            Axios.get(store.sightApiBaseUrl + "profile/get_access").then(resp => {
                localStorage.setItem('account', JSON.stringify(resp.data))

                // Check user access to sections with accounts variables
                if(to.matched.some(record => record.meta.isProtected)){
                    // console.log(JSON.parse(localStorage.getItem('account')))

                    const accessName = to.meta.feature
                    if (userCanAccess('features', accessName)){
                        return next();
                    }else{
                        return next('/unautorized');
                    }
                }else{
                    return next();
                }
            })
        }else{
            return next();
        }
    }

})
